import { useState, useEffect, useRef } from 'react';

export default function RulesSidebar() {
  const [open, setOpen] = useState(false);
  const touchStartX = useRef(null);

  // Swipe from left edge to open
  useEffect(() => {
    function handleTouchStart(e) {
      const x = e.touches[0].clientX;
      if (x < 30) touchStartX.current = x;
    }

    function handleTouchEnd(e) {
      if (touchStartX.current === null) return;
      const endX = e.changedTouches[0].clientX;
      if (endX - touchStartX.current > 60) setOpen(true);
      touchStartX.current = null;
    }

    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return (
    <>
      <button className="rules-toggle-btn" onClick={() => setOpen(true)}>Rules</button>
      <div
        className={`sidebar-overlay ${open ? 'open' : ''}`}
        onClick={() => setOpen(false)}
      />
      <aside className={`rules-sidebar ${open ? 'open' : ''}`}>
        <button className="sidebar-close-btn" onClick={() => setOpen(false)}>&times;</button>
        <h2>how to play</h2>
        <div className="rules-summary">
          <p>The goal is to be the first player to score <strong>10,000 points</strong>.</p>
          <p>On your turn, roll all six dice. Set aside at least one scoring die or combination. You can then end your turn and bank your points, or risk it all by re-rolling the remaining dice.</p>
          <p>If a roll results in no scoring dice, that's a <strong>NO DICE!</strong> You lose all points accumulated for that turn.</p>
        </div>
        <h3>redemption round</h3>
        <div className="rules-summary">
          <p>When the first player hits <strong>10,000+</strong>, everyone else gets one final turn to beat them. They pass any remaining scoring dice to the next player.</p>
          <p>Each remaining player chooses: <strong>inherit</strong> those passed dice (and build on the current leader's score) or <strong>start fresh</strong> from zero.</p>
          <p>Any amount over the current leader wins. Each time someone takes the lead, the new target cascades to the next player.</p>
        </div>
        <h3>scoring</h3>
        <ul className="rules-list">
          <li><strong>⚀</strong> = 100 pts</li>
          <li><strong>⚄</strong> = 50 pts</li>
          <li>3 of a Kind:
            <ul className="sub-rules">
              <li><strong>⚀⚀⚀</strong> = 1,000 pts</li>
              <li><strong>⚁⚁⚁</strong> = 200 pts</li>
              <li><strong>⚂⚂⚂</strong> = 300 pts</li>
              <li><strong>⚃⚃⚃</strong> = 400 pts</li>
              <li><strong>⚄⚄⚄</strong> = 500 pts</li>
              <li><strong>⚅⚅⚅</strong> = 600 pts</li>
            </ul>
          </li>
          <li>Straight (<strong>⚀⚁⚂⚃⚄⚅</strong>) = 1,500 pts</li>
          <li>3 NO DICE! in a row = <strong>-1,000 pts</strong></li>
          <li><strong>500 points</strong> minimum to get on the board.</li>
        </ul>
      </aside>
    </>
  );
}
